import React from 'react';
import { useNavigate } from 'react-router-dom';

const OnboardingFirstRequest: React.FC = () => {
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Submit request logic
    navigate('/onboarding/confirmation');
  };
  return (
    <form onSubmit={handleSubmit} className="max-w-md bg-white rounded-lg shadow p-8 mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-center">Submit Your First Request</h2>
      {/* Replace with your actual request form fields */}
      <div className="mb-4">
        <label className="block mb-1 font-medium">Request Title</label>
        <input type="text" required className="w-full border rounded px-3 py-2" />
      </div>
      <div className="mb-6">
        <label className="block mb-1 font-medium">Description</label>
        <textarea required className="w-full border rounded px-3 py-2" />
      </div>
      <button type="submit" className="w-full bg-primary text-white py-2 rounded font-semibold">Submit Request</button>
    </form>
  );
};

export default OnboardingFirstRequest; 